module.exports = __webpack_public_path__ + "media/assets/logo-3e53c3d03a49dc999819bea7e981823c7b22020f29ed70a2ae33544df288ebc9.png";